import { SavedSearchTypes } from './actionTypes';

export const getSavedSearchesList = (payload: any) => {
  return {
    type: SavedSearchTypes.GET_SAVED_SEARCHES,
    payload,
  };
};
export const getSavedSearchesSuccess = (payload: any) => {
  return {
    type: SavedSearchTypes.GET_SAVED_SEARCHES_SUCCESS,
    payload,
  };
};

export const getSavedSearchesFail = (error: any) => ({
  type: SavedSearchTypes.GET_SAVED_SEARCHES_FAIL,
  payload: error,
});

export const getFilterData = (payload: any) => ({
  type: SavedSearchTypes.GET_FILTER_DATA,
  payload,
});

export const getFilterDataSuccess = (payload: any) => {
  return {
    type: SavedSearchTypes.GET_FILTER_DATA_SUCCESS,
    payload,
  };
};

export const getFilterDataFail = (error: any) => ({
  type: SavedSearchTypes.GET_FILTER_DATA_FAIL,
  payload: error,
});

export const saveSearch = (data: any) => {
  return {
    type: SavedSearchTypes.SAVE_SEARCH,
    payload: { data },
  };
};

export const saveSearchSuccess = (data: any) => {
  return {
    type: SavedSearchTypes.SAVE_SEARCH_SUCCESS,
    payload: data,
  };
};

export const saveSearchFail = (data: any) => {
  return {
    type: SavedSearchTypes.SAVE_SEARCH_FAIL,
    payload: data,
  };
};
export const deleteSearches = (data: any) => {
  return {
    type: SavedSearchTypes.DELETE_SEARCHES,
    payload: data,
  };
};
export const deleteSearchesSuccess = (data: any) => {
  return {
    type: SavedSearchTypes.DELETE_SEARCHES_SUCCESS,
    payload: data,
  };
};
export const deleteSearchesFail = (error: any) => {
  return {
    type: SavedSearchTypes.DELETE_SEARCHES_FAIL,
    payload: error,
  };
};
